const initialState = {
	callsInProgress: [],
};

const getRootType = (type) => type.substring(0, type.lastIndexOf('_'));

const api = (state = initialState, action) => {
	if (action.type) {
		if (action.type.includes('REQUEST')) {
			return { ...state, callsInProgress: state.callsInProgress.concat(getRootType(action.type)) };
		}

		if (action.type.includes('FAILURE') || action.type.includes('SUCCESS')) {
			return { ...state, callsInProgress: state.callsInProgress.filter((type) => type !== getRootType(action.type)) };
		}
	}

	return state;
};

export default api;
